import React from "react";

const FlagTestLandingPage = (props) => {  
    return (
    <div>FLAG TEST PAGE</div>
    )
  };
  
  export default FlagTestLandingPage;
  